export const palette = {
  black: "#1E1E1F",
  blackest: "#000000",
  white: "#FFFFFF",
  offWhite: "#e6e6e6",
  orange: "#FBA928",
  orangeDarker: "#EB9918",
  grey: "#777777",
  lightGrey: "#939AA4",
  lighterGrey: "#CDD4DA",
  angry: "#dd3333",
  deepPurple: "#5D2555",

  blueJalaBase: "#1B77DF",
  blueJalaDark: "#0A6BBD",
  blueJalaDarker: "#004492",
  blueJalaLight: "#C7E1FF",

  blue700: "#004492",
  blue600: "#0A6BBD",
  blue500: "#1B77DF",
  blue400: "#4899F3",
  blue300: "#8AC1FE",
  blue200: "#C7E1FF",
  blueAzure: "#0084F3",
  blueSky: "#00B9FF",
  bluey: "#39A1F9",
  blueDark: "#0083F2",

  green600: "#379E2F",
  green500: "#4CB244",
  green400: "#78D271",
  green300: "#E3FCE2",
  green700: "#1C9014",

  red700: "#D12222",
  red600: "#DC1021",
  red500: "#F14250",
  red400: "#FD919A",
  red300: "#FFDADA",
  redLight: "#EE665C",
  red: "#E22B3A",
  redDark: "#EF4444",

  gray900: "#363637",
  gray800: "#454646",
  gray700: "#737373",
  gray600: "#A09E9E",
  gray500: "#BCBCBC",
  gray400: "#CDCDCD",
  gray300: "#DFDFDF",
  gray200: "#E5E5E5",
  gray100: "#F5F6F7",

  background: "#EAEFF5",
  backgroundGray: "#F1F5F9",

  lineDark: "#CCCCCC",
  lineBase: "#E5E5E5",
  lineLight: "#F6F6F6",

  ocean500: "#3C74BA",
  ocean200: "#DDE9F9",
  ocean100: "#E1F0FE",

  orange500: "#FF9D0B",
  orange300: "#FFF8E7",

  dust500: "#859ED1",

  ellipse: "#D1E7FF",

  yellowBox: "#FEFF04",
  yellowGreenBox: "#DCF929",
  yellowBase: '#FFF8E7',
  greenBrownBox: "#A9B529",
  greeenBox: "#54EB37",
  greenBlueBox: "#32A683",
  darkGreenBox: "#259912",
  darkerGreenBox: "#285B16",
  brownGreenBox: "#877626",
  ligthBrownBox: "#B8864C",
  brownBox: "#C07449",
  darkBrownRedBox: "#923B20",
  darkBrownBox: "#694917",
  blackBox: "#1C1D1C",
  darkestGrey: '#3A3B40',
  darkGrey: '#555555',
  lightGray: '#D8D8D8'
}
